import type { CourseItem, EventItem } from '@tc8l/nuxt-overview'
import type { GA4Item } from '~/types/tracking'

export function eventToGA4Item(
  event: EventItem,
  index?: number,
  isFilm?: boolean
): GA4Item {
  return {
    item_id: event.id,
    item_name: event.title,
    price: event.programs?.[0]?.price ?? undefined,
    item_category: event.genres?.[0]?.name ?? undefined,
    item_category2: event.attributes?.[0]?.name ?? undefined,
    index,
    item_list_id: isFilm ? 'films_overview' : 'events_overview',
    item_list_name: isFilm ? 'Films overview' : 'Events Overview',
  }
}

export function courseToGA4Item(
  course: CourseItem,
  index?: number,
): GA4Item {
  return {
    item_id: course.id,
    item_name: course.title,
    index,
    price: course.variants[0]?.prices[0]?.price ?? undefined,
    item_category: course.categories?.[0]?.name ?? null,
    item_category2: course.subcategories?.[0]?.name ?? null,
    item_category3: course.attributes?.[0]?.name ?? null,
    item_list_id: 'courses_overview',
    item_list_name: 'Courses Overview',
  }
}
